/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "dashboard/client-management/components/Navbars/AdminNavbar.js";
import AdminFooter from "dashboard/client-management/components/Footers/AdminFooter.js";
import Sidebar from "dashboard/client-management/components/Sidebar/Sidebar.js";

import routes, { routes_client } from "../../../routes";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  useEffect(() => {
    const tailwind = document.getElementById("tailwindcss");
    if (tailwind) tailwind.remove();
    const tailwindDemo = document.getElementById("tailwindcss-demo");
    if (tailwindDemo) tailwindDemo.remove();
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes_client) => {
    return routes_client.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes_client.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes_client[i].layout + routes_client[i].path) !==
        -1
      ) {
        return routes_client[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes_client}
        logo={{
          innerLink: "/client-admin/client-management/index5",
          imgSrc: require("../assets/img/brand/AECearth.jpeg"),
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes_client)}
          {/* <Route path="*" element={<Navigate to="/admin/index" replace />} /> */}
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
